import { supabase, isSupabaseConfigured } from './supabase';

export async function logMiracleScenario({
  goalDiff,
  minute,
  presetId = null,
  lang,
  teamA = null,
  teamB = null,
}) {
  if (!isSupabaseConfigured) return;

  const { error } = await supabase.from('miracle_calculator_scenarios').insert({
    goal_diff: goalDiff,
    minute,
    preset_id: presetId,
    lang,
    team_a_name: teamA?.name ?? null,
    team_a_mode: teamA?.mode ?? 'none',
    team_b_name: teamB?.name ?? null,
    team_b_mode: teamB?.mode ?? 'none',
  });

  if (error) {
    console.warn('Failed to log miracle calculator scenario:', error.message);
  }
}
